import { Button, Popconfirm } from 'antd'
import { flagsColumn } from '../../../components/Purchasing/Voucher/VouchersList'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import DateCell from '../../../elements/Table/Cells/DateCell'
import CustomTable from '../../../elements/Table/CustomTable'
import React from 'react'
import { Link } from 'react-router-dom'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import SumFooter from '../../../elements/Table/Footers/SumFooter'

const CheckboxTable = checkboxHOC(CustomTable)
const columns = [
  {
    Header: 'code',
    accessor: 'code',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/vouchers/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Date',
    accessor: 'date',
    Cell: DateCell,
    hideDefault: true,
    hideable: true,
  },
  { Header: 'Doc Ref', accessor: 'no' },
  {
    Header: 'Order',
    accessor: 'orders',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: original.orders[0] && original.orders[0]._id ?
            `purchasing/Order/${original.orders[0]._id.replace('purchases/','')}/update` : ''
          //pathname: `/purchasing/Order/${original.orders[0]._id.replace('purchases/','')}/update`,
        }}>
        {value && value.length === 1 && value[0] !== null ? value[0].code : value && value.length > 1 ? 'Multiple' : 'N/A'}
      </Link>
    ),
    width: 100,
    hideDefault: false,
    hideable: true,
  },
  { Header: 'Currency', accessor: 'currency' },
  {
    Header: 'Amount',
    accessor: 'subTotal.gross',
    hideDefault: false,
    hideable: true,
    Footer: SumFooter,
  },
  {
    Header: 'PayPlan',
    accessor: 'paymentPlan._key',
    hideDefault: true,
    hideable: true,
  },
  { Header: 'Due Date', accessor: 'dueDate', Cell: DateCell },
  { Header: 'Scheduled Date', accessor: 'scheduledDate', Cell: DateCell },
  { Header: 'Payee', accessor: 'payee.fn' },
  { Header: 'Bank', accessor: 'bank.accname', hideDefault: true, hideable: true },
  {
    Header: 'Company',
    accessor: 'company.fn',
    hideDefault: true,
    hideable: true,
  },
  { Header: 'Type', accessor: 'type', hideDefault: true, hideable: true },
  flagsColumn,
  {
    Header: 'Paid',
    accessor: 'paymentStatus',
    // hideDefault: true,
    // hideable: true,
    // Cell: MoneyCell,
    // Footer: SumFooter,
  },
  {
    Header: 'Status',
    accessor: 'status',
    hideDefault: true,
    hideable: true,
  },
  // {Header: 'File', accessor: 'file', Cell: FileCell},
]

function PaymentRequestList(props) {
  const {
    //paymentRequestList,
    paymentRequestFetching,
    paymentRequestFetch,
    //onShow,
    createWithLines,
    creating,
    //selectAll,
    isSelected,
    toggleSelection,
    //toggleAll,
    tableRef,
    selection,
    filteredData,
    paymentRequestCompany,
    paymentRequestOnChangeCompany,
  } = props

  const checkboxProps = {
    selectType: 'checkbox',
    // selectAll,
    isSelected,
    toggleSelection,
    // toggleAll,
  }

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={filteredData}
      defaultPageSize={20}
      isFilterable={true}
      fetching={paymentRequestFetching}
      fetch={paymentRequestFetch}
      columns={columns}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={paymentRequestCompany}
          onChange={paymentRequestOnChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      // ExtraButtons={() =>
      //   selectionData.length > 0 && (
      //     <strong style={{marginLeft: 10}}>
      //       {sumBy(selectionData, 'amount')}
      //     </strong>
      //   )
      // }
      CreateButton={() => (
        <Popconfirm
          placement="top"
          title={
            <span>
              Are you sure of your selections. This action will create a<strong> Draft Remittance </strong>and mark
              voucher payment status as <strong>pending</strong>
            </span>
          }
          onConfirm={createWithLines}
          okText="Yes"
          cancelText="No">
          <Button loading={creating} type={'primary'} size="small" icon={'plus'} disabled={selection.length === 0}>
            New
          </Button>
        </Popconfirm>
      )}
    />
  )
}

PaymentRequestList.propTypes = {}
PaymentRequestList.defaultProps = {}

export default PaymentRequestList
